import { c as _c } from "react/compiler-runtime";
import { ContentSummaryProps, ContentSummaryVariant } from "./types";
import { Base } from "./variants/Base";
import { BaseWide } from "./variants/BaseWide";
import { Hero } from "./variants/Hero";
import { DisappearingThumbnail } from "./variants/DisappearingThumbnail";
export const ContentSummary = props => {
  "use memo";

  const $ = _c(18);
  const {
    customTitle,
    image,
    title,
    variant
  } = props;
  let t0;
  if ($[0] !== customTitle || $[1] !== title) {
    t0 = customTitle?.trim() || title;
    $[0] = customTitle;
    $[1] = title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = image?.alt || "";
  let t2;
  if ($[3] !== image || $[4] !== t1) {
    t2 = {
      ...image,
      alt: t1
    };
    $[3] = image;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t0 || $[8] !== t2) {
    t3 = {
      ...props,
      title: t0,
      image: t2
    };
    $[6] = props;
    $[7] = t0;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const variantProps = t3;
  switch (variant) {
    case ContentSummaryVariant.Hero:
      {
        let t4;
        if ($[10] !== variantProps) {
          t4 = <Hero {...variantProps} />;
          $[10] = variantProps;
          $[11] = t4;
        } else {
          t4 = $[11];
        }
        return t4;
      }
    case ContentSummaryVariant.DisappearingThumbnail:
      {
        let t4;
        if ($[12] !== variantProps) {
          t4 = <DisappearingThumbnail {...variantProps} />;
          $[12] = variantProps;
          $[13] = t4;
        } else {
          t4 = $[13];
        }
        return t4;
      }
    case ContentSummaryVariant.BaseWide:
      {
        let t4;
        if ($[14] !== variantProps) {
          t4 = <BaseWide {...variantProps} />;
          $[14] = variantProps;
          $[15] = t4;
        } else {
          t4 = $[15];
        }
        return t4;
      }
    default:
      {
        let t4;
        if ($[16] !== variantProps) {
          t4 = <Base {...variantProps} />;
          $[16] = variantProps;
          $[17] = t4;
        } else {
          t4 = $[17];
        }
        return t4;
      }
  }
};